import styled from "styled-components";

import { TIMELINE_FONT_COLOR, TEXT_FONT, HEADER_FONT, ACCENT_YELLOW_COLOR, FONT_COLOR } from '../const'

export const StyledExperience = styled.div` 
  padding: 0 0 2vh 0;
`

export const StyledPositionTitle = styled.div` 
  font-size: 3.5vw; 
  font-family: ${HEADER_FONT};
  color: ${ACCENT_YELLOW_COLOR};
`

export const StyledText = styled.div`
  color: ${FONT_COLOR};
  font-size: 2vw; 
  font-family: ${TEXT_FONT};
`

export const StyledIndividualWrapper = styled.div`
height: 100vh;
width: 100vw;
padding-bottom: 20vh;
padding-top: 64px;
padding: 10vh 10vw 10vh 10vw;
background-image: ${props => props.isLandingPage? "url('nycBG1.jpg')" : "none"};
background-size: cover;
background-repeat: no-repeat;
background-color: ${props => props.background? props.background : ""};

`

export const StyledAnchorNames = styled.a`
  padding-top: 10vh;
  font-size: 6vw; 
  color: ${FONT_COLOR};
  
  &:hover {
    text-decoration: none;
    color: ${ACCENT_YELLOW_COLOR};
  }
`

export const StyledSectionContent = styled.div`
  color: ${FONT_COLOR};
  padding-bottom: 10vh;
`

export const createWebpageSection = ({anchorName, header, content, SecondSection, background}) => (
    <StyledIndividualWrapper background={background}> 
      <StyledAnchorNames name={anchorName}>#{header}</StyledAnchorNames>
      <StyledSectionContent>{content}</StyledSectionContent>  
      {SecondSection ? <SecondSection/> : null}
    </StyledIndividualWrapper> 
)